import { useState } from 'react';
import {
  ImagePayload,
  UploadImageModalProps,
} from 'app/components/Core/UploadImageModal/types';
import { DropImageModal } from './DropImageModal';
import { CropImageModal } from './CropImageModal';

export const UploadImageModal = ({
  title,
  image,
  open,
  onClose,
  startPolling,
  effect,
  minAllowedDimension,
}: UploadImageModalProps) => {
  const [avatar, setAvatar] = useState<ImagePayload | undefined>(image);

  const handleClose = () => {
    setAvatar(undefined);
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <>
      <DropImageModal
        open={!avatar}
        setAvatar={setAvatar}
        onClose={handleClose}
        minAllowedDimension={minAllowedDimension}
      />
      <CropImageModal
        title={title}
        avatar={avatar}
        onClose={handleClose}
        startPolling={startPolling}
        effect={effect}
      />
    </>
  );
};
